import React, { useContext, useState } from 'react';
import styled from 'styled-components/native';
import { View, Text, Modal } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';

import AuthContext from 'app/src/contexts/AuthContext';

import * as colors from '../styles/colors';
import AccountMenu from './account/Menu';
import Notifications from './Notifications';
import ResourceNotifications from 'app/src/components/Notifications/Resource';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 0.7;
  align-items: center;
  height: 78px;
  z-index: 10000;
`;

const SellerName = styled(Text)`
  font-weight: 800;
  font-size: 20px;
`;

const HeaderNavigation = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { user } = useContext(AuthContext);

  const showUsers = user?.policies?.find(policy => (
    'SellerUser' === policy.model && 'show' === policy.action
  ));

  return (
    <NavbarContainer>
      <SellerName>{user?.seller.name}</SellerName>
      <Link to={`/assets`}>
        <Text>Assets</Text>
      </Link>
      <Link to="/reports/sale">
        <Text>Past Sale Reports</Text>
      </Link>
      <Link to="/reports">
        <Text>Other Reports</Text>
      </Link>
      {showUsers && (
        <Link to={`/users`}>
          <Text>Users</Text>
        </Link>
      )}
      {user && (
        <ResourceNotifications resource={user.seller} labeled />
      )}
      {user && <Notifications user={user} />}
      <FontAwesomeIcon
        icon={faCircleUser}
        size='2xl'
        style={{color: colors.elRed}}
        onClick={() => setShowMenu(!showMenu)}
      />
      {showMenu &&
        <AccountMenu />
      }
    </NavbarContainer>
  )
};

export default HeaderNavigation;
